__webpack_require__.p = "https://assets.eu.daedalus.fih.io/_next/";